<template>
  <div class="classes-widget">
    <div class="teams-header">
      <widgetSearch icon="right" @keyup="searchAll" :placeholder="APPLICATION_NAME == 'meritios'
        ? 'Search student'
        : 'Search consultant'
        ">
      </widgetSearch>
    </div>
    <!-- For Super manager -->
    <div class="teams-body" v-if="isPermited">
      <loading :height="20" color="#1ba5a4" :opacity="1" :width="20" :active.sync="is_loading" :is-full-page="false"
        :can-cancel="false" background-color="#fff" class="loader"></loading>

      <div class="departiment-item" v-for="(item, i) in department_data" :key="i">
        <div class="department-header" :class="{ active: item.expanded }" @click="expandDepartment(item, i)">
          <div class="start">
            <label v-if="APPLICATION_NAME == 'meritios'" class="dep-label">{{ item.name | validate }}
            </label>
            <label v-if="APPLICATION_NAME == 'consultified'" class="dep-label">{{ item.name | validate }}
            </label>
          </div>
          <div class="options">
            <div class="class-count">
              <label v-if="APPLICATION_NAME == 'meritios'" class="dep-label">
                {{ item.teams.length | validate }} Classes</label>
              <label v-if="APPLICATION_NAME == 'consultified'" class="dep-label">
                {{ item.teams.length | validate }} Teams</label>
            </div>
            <button>
              <img v-if="item.expanded" src="@/assets/admin-icon/green-caret-up.svg" />
              <img v-else src="@/assets/admin-icon/gray-caret-down.svg" />
            </button>
          </div>
        </div>
        <div class="department-body" v-show="item.expanded && item.teams.length > 0">
          <div class="teams-widget">
            <template v-for="(team, index) in item.teams">
              <div class="team-row" :key="index">
                <div class="team-header" :class="{ active: team.expanded }" @click="expandTeam(item, team)">
                  <div class="class-profile-widget">
                    <widgetProfile :size="26" :text_size="12" :title="team.name"
                      :subtitle="APPLICATION_NAME == 'meritios' ? team.consultants.length + ' Students' : team.consultants.length + ' Consultants'"
                      file_name="" :path="$fullUrl('images/profiles/')">
                    </widgetProfile>
                  </div>

                  <div class="student-count-widget">
                    <button class="btn-expand">
                      <img v-if="!team.expanded" src="@/assets/admin-icon/gray-caret-up.svg" />
                      <img v-else src="@/assets/admin-icon/gray-caret-down.svg" />
                    </button>
                  </div>
                </div>
                <div class="team-body" v-show="team.expanded && team.consultants.length > 0">
                  <div class="student-list-widget">
                    <template v-for="(consultant, index) in team.consultants">
                      <div :key="index" @click="selectConsultant(item, team, consultant)" class="student-profile-content">
                        <widgetProfile :title="consultant.first_name + ' ' + consultant.last_name
                          " :subtitle="consultant.profile ? consultant.profile.address : ''
    " :size="26" :text_size="12" :contentWidth="0" :file_name="consultant.profile_picture"
                          :path="$fullUrl('images/profiles/')"></widgetProfile>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div v-if="item.expanded && item.teams.length == 0" class="department-body">
          <label v-if="APPLICATION_NAME == 'consultified'">No team in this department</label>
          <label v-if="APPLICATION_NAME == 'meritios'">No class in this department</label>
        </div>
      </div>
    </div>
    <!-- For team manager -->
    <div class="teams-body" v-else>
      <loading :height="20" color="#1ba5a4" :opacity="1" :width="20" :active.sync="is_loading" :is-full-page="false"
        :can-cancel="false" background-color="#fff" class="loader"></loading>
      <div class="departiment-item">
        <div class="department-body" v-if="teams_data.length > 0">
          <div class="teams-widget">
            <template v-for="(team, index) in teams_data">
              <div class="team-row" :key="index">
                <div class="team-header" :class="{ active: team.expanded }">
                  <div class="profile-alphabet" @click="expandTeam(null, team)">
                    <span>{{ $nameInitials(team.name) | validate }}</span>
                  </div>
                  {{ team.name }}
                </div>
                <div class="team-body" v-show="team.expanded && team.consultants.length > 0">
                  <div class="student-list-widget">
                    <template v-for="(consultant, index) in team.consultants">
                      <div :key="index" @click="selectConsultant(item, team, consultant)" class="student-profile-content">
                        <widgetProfile :title="consultant.first_name + ' ' + consultant.last_name
                          " :subtitle="consultant.profile ? consultant.profile.address : ''
    " :file_name="consultant.profile_picture" :path="$fullUrl('images/profiles/')">
                        </widgetProfile>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div v-else class="department-body">
          <label v-if="APPLICATION_NAME == 'meritios'">No class Available</label>
          <label v-if="APPLICATION_NAME == 'consultified'">No team Available</label>
        </div>
      </div>
    </div>
    <!-- End -->
  </div>
</template>
<script>
import { eventBus } from "@/main";
export default {
  name: "classes-widget",
  components: {},
  props: {},

  data() {
    return {
      show_form: false,
      department_data: [],
      department_show_form: false,
      teams_data: [],
      search_input: "",
      selected_consultant: null,
      is_loading: false,
      consultant_cvs: [],
      showExport: false,
      checked_consultant: [],
      selected_download_cv: [],
      cv_download_milt_loading: false,
      download_cv_loading: false,
      cvs_path: [],
      active_department: null,
    };
  },
  computed: {
    isPermited() {
      let vm = this;
      return vm.$localStorage.get("main_role") != "team-manager";
    },
  },
  watch: {},
  mounted() {
    let vm = this;
    vm.getTeamDepData();
  },
  methods: {
    searchAll({ target }) {
      let vm = this;
      let query = target.value;
      if (query) {
        vm.is_loading = true;
        vm.$store
          .dispatch("ORGANIZATION_SEARCH_USER_IN_DEPARTMENT", { query: query })
          .then((response) => {
            vm.is_loading = false;
            if (vm.$localStorage.get("role") == "team-manager") {
              vm.teams_data = response.data;
              vm.teams_data.forEach((team) => {
                eventBus.$set(team, "expanded", true);
                team.consultants.forEach((consultant) => {
                  eventBus.$set(consultant, "expanded", true);
                  eventBus.$set(consultant, "checked", false);
                });
              });
            } else {
              vm.department_data = response.data.map((item, index) => {
                if (vm.active_department == index) {
                  eventBus.$set(item, "expanded", true);
                } else {
                  eventBus.$set(item, "expanded", true);
                }
                item.teams = item.teams.map((team) => {
                  eventBus.$set(team, "expanded", true);
                  team.consultants.forEach((consultant) => {
                    eventBus.$set(consultant, "expanded", true);
                    eventBus.$set(consultant, "checked", false);
                  });
                  return team;
                });
                return item;
              });
            }
            vm.is_loading = false;
          })
          .catch((error) => {
            vm.is_loading = false;
            console.error({ error });
          });
      } else {
        vm.getTeamDepData();
      }
    },
    selectConsultant(department, team, consultant) {
      let vm = this;
      vm.$emit("consultantSelected", consultant);
    },
    getTeamDepData() {
      let vm = this;
      vm.is_loading = true;
      vm.$store
        .dispatch("GET_ALL_USER_INFO")
        .then((response) => {
          if (vm.$localStorage.get("role") == "team-manager") {
            vm.teams_data = response.data;
            vm.teams_data.forEach((team) => {
              team.consultants.forEach((consultant) => {
                eventBus.$set(consultant, "checked", false);
              });
            });
          } else {
            vm.department_data = response.data.map((item, index) => {
              if (vm.active_department == index) {
                eventBus.$set(item, "expanded", true);
              } else {
                eventBus.$set(item, "expanded", false);
              }
              item.teams = item.teams.map((team) => {
                eventBus.$set(team, "expanded", false);
                team.consultants.forEach((consultant) => {
                  eventBus.$set(consultant, "checked", false);
                });
                return team;
              });
              return item;
            });
          }
          vm.is_loading = false;
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
          console.error({ error });
        });
    },
    expandDepartment(item, i) {
      let vm = this;
      vm.cvs_path = [];
      vm.cvs_path.push({ label: item.name });
      item.expanded = !item.expanded;
      vm.active_department = i;
      vm.$emit("departmentSelected", item);
    },
    expandTeam(department, team) {
      let vm = this;
      vm.cvs_path = [];
      vm.cvs_path.push({ label: department.name });
      vm.cvs_path.push({ label: team.name, active: true });
      team.expanded = !team.expanded;
      vm.$emit("teamSelected", team);
    },
  },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";

.classes-widget {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-bottom: 20px;

  .teams-header {
    height: 35px;
  }

  .teams-body {
    background: #fff;
    height: calc(100% - 35px);
    overflow-y: auto;
    position: relative;

    .departiment-item {
      margin-bottom: 5px;

      .department-header {
        height: 35px;
        background: #e7e7e7;
        align-items: center;
        display: flex;
        padding: 0px 10px;
        border-radius: 5px;
        justify-content: space-between;
        cursor: pointer;
        margin-bottom: 5px;

        .start {
          width: 52%;
          cursor: pointer;
          overflow: hidden;
          text-decoration: none;
          text-overflow: ellipsis;
          white-space: nowrap;

          .dep-label {
            color: #000000;
            font-size: 12px;
          }
        }

        &.active {
          background: #ffffff;
          border: 1px solid #1ba5a4;
          box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
          border-radius: 5px;

          .start {
            cursor: pointer;

            .dep-label {
              color: #1ba5a4;
              font-size: 12px;
            }
          }
        }

        .options {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .class-count {
            font-family: "Nunito";
            font-style: normal;
            font-weight: 400;
            font-size: 11px;
            color: #656565;
          }

          button {
            img {
              width: 10px;
            }
          }
        }
      }

      .department-body {
        padding-left: 15px;
        padding-top: 5px;

        .teams-widget {
          .team-row {
            display: flex;
            flex-direction: column;
            background: #f3f3f3;
            border-radius: 5px;
            margin-bottom: 5px;
            padding: 3px;

            .team-header {
              height: 35px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              border-radius: 5px;
              margin-bottom: 2px;
              padding-left: 5px;
              background: #ffffff;
              border-radius: 5px;
              cursor: pointer;

              &.active {}

              .class-profile-widget {
                width: calc(100% - 20px);
                display: flex;
              }

              .student-count-widget {
                display: flex;
                align-items: center;
                width: 16px;

                .btn-expand {
                  display: flex;
                  align-items: center;
                }
              }
            }

            .team-body {
              padding-left: 30px;

              .student-list-widget {
                .student-profile-content {
                  padding: 8px 0px;
                  border-bottom: 0.5px solid #c4c4c4;
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>